var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767B85",
    d: "M15.864 3.87V.498a.502.502 0 0 0-.202-.402.506.506 0 0 0-.446-.073L5.168 3.215a.498.498 0 0 0-.346.475v9.835c-.527-.365-1.2-.564-1.907-.564-.748 0-1.458.225-2 .63-.581.438-.902 1.03-.902 1.675s.32 1.237.902 1.676c.542.405 1.248.63 2 .63.75 0 1.458-.225 1.999-.63.582-.439.902-1.031.902-1.676V7.431l9.054-2.88v5.767c-.526-.365-1.2-.564-1.907-.564-.748 0-1.458.225-2 .63-.581.438-.902 1.03-.902 1.675s.32 1.237.902 1.675c.542.406 1.249.63 2 .63.75 0 1.458-.224 2-.63.58-.438.901-1.03.901-1.675V3.87zM2.914 16.577c-1.034 0-1.907-.6-1.907-1.31 0-.711.873-1.312 1.908-1.312 1.034 0 1.907.6 1.907 1.311 0 .715-.873 1.311-1.907 1.311zM5.817 6.385V4.051l9.054-2.876V3.51L5.816 6.385zm7.15 6.985c-1.034 0-1.907-.6-1.907-1.31 0-.711.873-1.312 1.907-1.312 1.035 0 1.908.6 1.908 1.311-.004.71-.877 1.311-1.908 1.311z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.d3a3efa4ed7e5e5d59f986807f84d3a5.svg";
export { ForwardRef as ReactComponent };